/// <reference path="prayerfeaturesaga.js" />
import "regenerator-runtime/runtime";
import { all, fork } from "redux-saga/effects";
import * as ssoSaga from "./ssoSaga";
import errorSaga from "./errorSaga";
import commonSaga from "./commonSaga";
import prayerFeatureSaga from "./prayerFeatureSaga";

// register watcher saga(s) and export a single generator function as the root saga.
export default function* startForeman() {
    let watchers = [
        fork(ssoSaga.watchUserAuthenticate),
        fork(errorSaga),
        fork(commonSaga),
        fork(prayerFeatureSaga)
    ];

    try {
        yield all(watchers);
    }
    catch (err) {
        console.error(err);
    }
}